'use client';

import { HeaderSectionProps } from 'components/padi-ui/header-section';
import HeaderStar, { HeaderStarProps } from 'components/padi-ui/header-star';
import { TasticProps } from 'frontastic/tastics/types';
import { memo } from 'react';

const HeaderStarTastic = ({ data }: TasticProps<Omit<HeaderStarProps, 'headerSectionProps'> & HeaderSectionProps>) => {
  const { rating, ratingDescription, textGuide, sectionId, title, ...headerSectionProps } = data;

  return (
    <HeaderStar
      rating={rating}
      ratingDescription={ratingDescription}
      textGuide={textGuide}
      sectionId={sectionId}
      headerSectionProps={{ ...headerSectionProps, title: title || '' }}
    />
  );
};

export default memo(HeaderStarTastic);
